export function getEmbeddedAssetUri(hash, type) {
  return null;
}